import { createAction } from '@reduxjs/toolkit';
import { createActionWithCallback } from 'core/store/utils';
import { RequestError, ProfilParams } from 'types';
import { State } from './types';

export const createProfil = createActionWithCallback<void, Error>()(
  'profil/create',
  (profil: Omit<ProfilParams, 'id'>) => ({
    payload: profil,
  })
);

export const createdProfil = createAction('profil/created', (data?: State['data'], error?: RequestError) => ({
  payload: error || data,
  error: Boolean(error),
}));

export const updateProfil = createActionWithCallback<void, Error>()('profil/modify', (profil: ProfilParams) => ({
  payload: profil,
}));

export const updatedProfil = createAction('profil/modified', (data?: State['data'], error?: RequestError) => ({
  payload: error || data,
  error: Boolean(error),
}));

export const deleteProfil = createAction('profil/delete', (payload: { id: string }) => ({
  payload,
}));

export const deletedProfil = createAction('profil/deleteded', (error?: RequestError | Response) => ({
  payload: error,
  error: Boolean(error),
}));

export default {
  createdProfil,
  createProfil,
  updateProfil,
  updatedProfil,
  deleteProfil,
  deletedProfil,
};
